// extracted by mini-css-extract-plugin
export var button = "modal-module--button--1S86k";
export var modal = "modal-module--modal--12sYr";
export var overlay = "modal-module--overlay--2IoP_";
export var close__icon = "modal-module--close__icon--1dsNY";